<div class="modalBox">
  <div mat-dialog-title class="smallMargin description">{{ 'RESET_DESCRIPTION' | translate}}</div>
  <mat-dialog-content class="mat-typography d-flex justify-content-center">
    <input placeholder="example@example.com" class="PasswordResetInput smallMargin smoothEdge w-100" type="text">
  </mat-dialog-content>
  <mat-dialog-actions align="center" class="d-flex flex-nowrap justify-content-around">
    <button
      mat-raised-button
      w-100
      class="button-reset primary"
      (mouseenter)="changeSubmitButtonState()"
      (mouseleave)="changeSubmitButtonState()"
      [@buttonHover]="submitButtonState"
    >
      <span>
        {{ 'RESET_PASSWORD' | translate}}
      </span>
    </button>
    <button
      mat-raised-button
      cdkFocusInitial
      w-100
      class="button-cancel primary"
      (click)="dialogRef.close()"
      (mouseenter)="changeCancelButtonState()"
      (mouseleave)="changeCancelButtonState()"
      [@buttonHover]="cancelButtonState"
    >
      {{ 'CANCEL' | translate}}
    </button>
  </mat-dialog-actions>
</div>
